/**
 * Issue Navigation
 **/
export const IssueNavigation = function( $ ) {

	const IssueNavigation = {

		elements: {
			$issueNavigation: $( '.issues-navigation' ),
			$pastIssues: $( '.past-issues' ),
			$pastIssuesYears: $( '.past-issues-years' ),
			$pastIssuesYearTitle: $( '.past-issues-year-title' ),
		},

		openYear( year ) {
			const $yearItem = IssueNavigation.elements.$pastIssuesYears.find( '.past-issues-year[data-year="' + year + '"]' );
			$yearItem.find( '[data-fa-i2svg]' ).addClass( 'fa-minus' ).removeClass( 'fa-plus' );
			$yearItem.addClass( 'is-open' );
			$yearItem.find( '.year-issues' ).slideDown();
		},

		closeYear( year ) {
			const $yearItem = IssueNavigation.elements.$pastIssuesYears.find( '.past-issues-year[data-year="' + year + '"]' );
			$yearItem.find( '[data-fa-i2svg]' ).removeClass( 'fa-minus' ).addClass( 'fa-plus' );
			$yearItem.removeClass( 'is-open' );
			$yearItem.find( '.year-issues' ).slideUp();
		},

		closeAll( callback ) {
			$( '.past-issues-year' ).each( function() {
				$( this ).find( '[data-fa-i2svg]' ).removeClass( 'fa-minus' ).addClass( 'fa-plus' );
				$( this ).removeClass( 'is-open' );
				$( this ).find( '.year-issues' ).slideUp();
			} ).promise().done( function() {
				if ( undefined !== callback ) {
					callback();
				}
			} );
		},

	};

	IssueNavigation.elements.$pastIssuesYearTitle.click( function( e ) {
		e.preventDefault();

		const $item = $( this );
		const $yearItem = $item.parents( '.past-issues-year' );
		const year = $yearItem.data( 'year' );

		if ( $yearItem.hasClass( 'is-open' ) ) {
			IssueNavigation.closeYear( year );
		} else {
			IssueNavigation.closeAll( function() {
				IssueNavigation.openYear( year );
			} );
		}

	} );

	return IssueNavigation;

}( jQuery );
